import { UserIdSchema } from "@core/domains/identity";
import { identity } from "@core/foundation/function";
import { createModel, createModelSchemas } from "@core/foundation/model";
import { z } from "@core/zod";

import { ReservationIdSchema } from "./reservation.ts";

const ReservedBalanceEntrySchema = z.object(
  { amount: z.decimal().positive(), expiresAt: z.iso.datetime() },
  {
    amount: "The credit the hold takes, as a decimal string.",
    expiresAt: "When the hold expires, as an ISO 8601 timestamp.",
  },
);

export const ReservedBalance = createModel({
  create: (item, schema) => {
    return { ...schema.decode(item), etag: null };
  },
  schemas: createModelSchemas({
    base: z.object(
      {
        etag: z.string().nullable(),
        holds: z.record(ReservationIdSchema, ReservedBalanceEntrySchema),
        principalId: UserIdSchema,
      },
      {
        etag: "The record's version, which storage stamps for concurrency.",
        holds:
          "The held amounts, keyed by the id of the reservation holding each.",
        principalId: "The id of the user whose holds the record carries.",
      },
    ),
    derive: {
      create: schema => schema.omit({ etag: true }),
      recovery: identity,
      update: schema => schema.pick({ holds: true }).partial(),
    },
  }),
  update: (item, update, schema) => {
    return { ...item, ...schema.decode(update) };
  },
});

export interface ReservedBalance
  extends z.infer<typeof ReservedBalance.schema> {}
